import { Observable } from 'rxjs';
import { Categoria } from "./categoria";
import { Pais } from './pais';
import { BusinessUnit } from '../../dashboard/models/business-unit';
import { KPIDistribuidorOpcion } from './KPIDistribuidorOpcion';

export class Distributor {
  id: number;
  nombre: string;
  codigo: string;
  razonSocial: string;
  cuit: string;
  categoria: Categoria;
  kpiDistribuidorOpcion: KPIDistribuidorOpcion;
  paisNodumId: number;
  paisOrigenId: number;
  distribuidorPrincipalId?: number;
  pais: Pais;
  unidadesNegocio: BusinessUnit[];
  logo: string;
  anioFiscal: number;
  nomeSelect: string;
  usuarioResponsavel: string;
}

export abstract class DistributorData {
  abstract getList(): Observable<Distributor[]>;
  abstract getDistribuidoresByGerente(gerenteId: number): Observable<Distributor[]>;
}
